import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Galdera Notes" mdxType="SEO" />
    <h2 {...{
      "id": "galdera-notes"
    }}>{`GALDERA NOTES`}</h2>
    <h3 {...{
      "id": "cyrus-ch1"
    }}>{`Cyrus Ch.1`}</h3>
    <p>{`After getting cutscened outside the palace, go back in and turn right for a `}<strong parentName="p">{`Thunder S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`During the scrutinize mission, scrutinize the guard by the screen split for a `}<strong parentName="p">{`Light S`}</strong>{`.`}<br parentName="p"></br>{`
`}<em parentName="p">{`Quiz: Option 1, Option 2`}</em><br parentName="p"></br>{`
`}{`When the dungeon opens, go to the south screen and scrutinize the girl in the plaza for a `}<strong parentName="p">{`Light M`}</strong></p>
    <h5 {...{
      "id": "weapon-shop"
    }}>{`Weapon Shop`}</h5>
    <p>{`Buy Quartz Rod and equip`}</p>
    <p>{`Subterranean Study: Kill 2 encounters for 10 JP. Pick `}<strong parentName="p">{`Light S`}</strong>{` to the far right of the boss trigger.`}</p>
    <h4 {...{
      "id": "russell"
    }}>{`Russell`}</h4>
    <p><em parentName="p">{`Heal when below 40 HP`}</em><br parentName="p"></br>{`
`}{`1. Fireball`}<br parentName="p"></br>{`
`}{`2. Thunder S`}<br parentName="p"></br>{`
`}{`3. Light S`}<br parentName="p"></br>{`
`}{`4. Icewind`}<br parentName="p"></br>{`
`}{`5. Staff x3`}<br parentName="p"></br>{`
`}{`6. Light S`}<br parentName="p"></br>{`
`}{`7. Staff`}<br parentName="p"></br>{`
`}{`8. Staff x3`}<br parentName="p"></br>{`
`}{`9. Fireball x4`}</p>
    <p>{`Complete Sidequest: Kit the Traveler`}</p>
    <p>{`Go to The Whistlewood in North Atlasdam Flats and pick up `}<strong parentName="p">{`$1500`}</strong>{` red chest.`}<br parentName="p"></br>{`
`}{`Kill one of these encounters with `}<strong parentName="p">{`Light M`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul">{`2 Flatlands Froggen IV, 2 Spud Bugs (need 2 JP extra)`}</li>
      <li parentName="ul">{`2 Flatlands Froggen V, 2 Spud Bugs`}</li>
      <li parentName="ul">{`5 Spud Bugs`}</li>
      <li parentName="ul">{`Anything with a Cait`}</li>
    </ul>
    <h5 {...{
      "id": "skills"
    }}>{`Skills`}</h5>
    <p>{`Cyrus: Lightning Blast, Blizzard, Evasive Maneuvers`}</p>
    <p>{`Go to `}<strong parentName="p">{`Scholar Shrine`}</strong>{`. Pick `}<strong parentName="p">{`Wind Amulet`}</strong>{`. Go to `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <p>{`In Noblecourt, scrutinize the woman by the entrance and pick `}<strong parentName="p">{`Thunder L`}</strong>{` (30%).`}</p>
    <p>{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`, go to `}<strong parentName="p">{`Rippletide`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <h4 {...{
      "id": "mikk--makk"
    }}>{`Mikk & Makk`}</h4>
    <p>{`Thunder L`}</p>
    <p>{`Tag `}<strong parentName="p">{`Cobbleston`}</strong>{`, get `}<strong parentName="p">{`$1200`}</strong>{` chest on the way. Go to `}<strong parentName="p">{`North Stonegard Pass`}</strong>{`. Get `}<strong parentName="p">{`Warrior Shrine`}</strong>{`, tag `}<strong parentName="p">{`Stonegard`}</strong>{`, go to `}<strong parentName="p">{`Moonstruck Coast`}</strong>{`. S&Q at save, get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`, tag `}<strong parentName="p">{`Goldshore`}</strong>{`. Head towards `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <p>{`Reload at save before shrine, and get shrine, then go to `}<strong parentName="p">{`Goldshore`}</strong>{`, scrutinize old man (get item later) and leave. Enter `}<strong parentName="p">{`West Grandport Coast`}</strong>{` and get `}<strong parentName="p">{`Wind L`}</strong>{`, go north to reload screen, go back in to get `}<strong parentName="p">{`$20000`}</strong>{`, and save/reload at save point.  Get `}<strong parentName="p">{`Thunder L`}</strong>{` from the chest south of save point, and enter `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <p>{`Buy the `}<strong parentName="p">{`+50 accuracy`}</strong>{` necklace at the weapon shop, go to tavern and buy `}<strong parentName="p">{`Nourishing M`}</strong>{`, `}<strong parentName="p">{`Fortifying M`}</strong>{`, and `}<strong parentName="p">{`Magic M`}</strong>{` from the merchant in the middle.  On the next screen, buy a `}<strong parentName="p">{`Pom L`}</strong>{` from the noble in red, get the `}<strong parentName="p">{`Silver-Filled Pouch`}</strong>{`, buy another `}<strong parentName="p">{`Pom L`}</strong>{` from the man in green, and all `}<strong parentName="p">{`pomegranates`}</strong>{` from the lady in red.  On the next screen, get `}<strong parentName="p">{`$25000 + Artwork`}</strong>{`, and TP to `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <p>{`Go east to the next screen, go down the stairs and buy all `}<strong parentName="p">{`M Soulstones`}</strong>{` from the guy guarding the first house.  Buy `}<strong parentName="p">{`Mighty Belt`}</strong>{` and `}<strong parentName="p">{`Elemental Augmentor`}</strong>{` from the old man at the end, then TP to `}<strong parentName="p">{`Cobbleston`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Between now and Guardian, you have 3 M Stones to use to clear battles as you please. 1 is generally used for Ravus Manor so it's 2 for other random battles.`}</p>
    </blockquote>
    <p>{`Tag `}<strong parentName="p">{`Sunshade`}</strong>{`, get the `}<strong parentName="p">{`Old Coin`}</strong>{` on the way. Tag `}<strong parentName="p">{`Clearbrook`}</strong>{`. Go to `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch2-start"
    }}>{`Cyrus Ch.2 Start`}</h3>
    <p>{`Get the `}<strong parentName="p">{`Wind M`}</strong>{` in Odette’s house. (Quiz: all option 2) Leave when you unlock the dungeon and go to `}<strong parentName="p">{`Bolderfall`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch1"
    }}>{`Therion Ch.1`}</h3>
    <p>{`Kill encounter in Ravus Manor with `}<strong parentName="p">{`M Stone`}</strong>{`.`}</p>
    <h4 {...{
      "id": "heathcote"
    }}>{`Heathcote`}</h4>
    <p>{`Thunder L + M Stone`}</p>
    <p>{`Steal `}<strong parentName="p">{`Energizing Pomegranate, Nourishing Nut`}</strong>{` from lady by entrance.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You have 1 Wind L to use on either Victor's Hollow or Cleric Shrine battle if you get them.`}</p>
    </blockquote>
    <p>{`Tag `}<strong parentName="p">{`Victor’s Hollow`}</strong>{`, Purchase `}<strong parentName="p">{`Nourishing M, Invigorating M, Magic M`}</strong>{` from the man by the entrance. Get `}<strong parentName="p">{`Hunter Shrine`}</strong>{` and `}<strong parentName="p">{`Olive L`}</strong>{`. Get `}<strong parentName="p">{`Cleric Shrine`}</strong>{`, tag `}<strong parentName="p">{`Stillsnow`}</strong>{`, and go to `}<strong parentName="p">{`Maw of the Ice Dragon`}</strong>{`. Get `}<strong parentName="p">{`$30000`}</strong>{` in the first red chest you see and `}<strong parentName="p">{`Adamantine Hat`}</strong>{` in the purple chest to the south.  TP to `}<strong parentName="p">{`Sunshade`}</strong>{`, head out to the right.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Dancer Shrine`}</strong>{`, reload at south exit, tag `}<strong parentName="p">{`Wellspring`}</strong>{`. Get `}<strong parentName="p">{`Thunder L`}</strong>{` + `}<strong parentName="p">{`$20000`}</strong>{` chest in screen before `}<strong parentName="p">{`Marsalim`}</strong>{`, reload at `}<strong parentName="p">{`Marsalim Catacombs`}</strong>{`.`}</p>
    <p>{`Enter `}<strong parentName="p">{`Marsalim`}</strong>{`, buy `}<strong parentName="p">{`Invigorating M, Magic M, Resistant M`}</strong>{` from guy by entrance near shop. Go to palace, buy 2 `}<strong parentName="p">{`Pom M`}</strong>{` from left guard, pick `}<strong parentName="p">{`Tempest Amulet`}</strong>{`, purchase `}<strong parentName="p">{`Fire L and Wind L`}</strong>{` from right guard. Pick `}<strong parentName="p">{`Enchanted Circlet, $25,000, High House Armor`}</strong>{` in the three red chests in the room to the far right.`}</p>
    <p>{`TP to `}<strong parentName="p">{`Stonegard`}</strong>{`, go to `}<strong parentName="p">{`West Everhold Pass`}</strong>{`. Pick `}<strong parentName="p">{`Light L`}</strong>{` + `}<strong parentName="p">{`Pouch`}</strong>{`, `}<strong parentName="p">{`Save & Reload`}</strong>{`, tag `}<strong parentName="p">{`Everhold`}</strong>{`. Go back and `}<strong parentName="p">{`Save & Reload`}</strong>{`, get `}<strong parentName="p">{`Pom M`}</strong>{`, go to `}<strong parentName="p">{`West Everhold Tunnels`}</strong>{`.`}</p>
    <p>{`Get `}<strong parentName="p">{`Pom L`}</strong>{`, reset steps. get `}<strong parentName="p">{`$35000`}</strong>{`, `}<strong parentName="p">{`Knowledge Staff`}</strong>{`, `}<strong parentName="p">{`Death Cleaver`}</strong>{`, resetting steps in between all of them.`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch2-start"
    }}>{`Therion Ch.2 Start`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Sorcerer's Robe`}</strong>{` from woman standing in front of house to the right of the plaza. Steal `}<strong parentName="p">{`Oasis Hat`}</strong>{` from Impresario in Western Noblecourt Flats. Go to `}<strong parentName="p">{`Flamesgrace`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ophilia-ch1"
    }}>{`Ophilia Ch.1`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Nourishing Mx2, Invigorating Mx2, Magic Mx3`}</li>
        <li parentName="ul">{`Tressa: Nourishing S, Resistant M`}</li>
        <li parentName="ul">{`Therion: Fortifying M`}</li>
      </ul>
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Optimize, Elemental Augmentor`}</li>
        <li parentName="ul">{`Tressa: Enchanted Circlet`}</li>
        <li parentName="ul">{`Ophilia: Optimize`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "guardian"
    }}>{`Guardian`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Blizzard`}</li>
      <li parentName="ul">{`Tressa: Pom Cyrus`}</li>
      <li parentName="ul">{`Therion: Attack x2`}</li>
      <li parentName="ul">{`Ophilia: Attack x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Lightning Blast x4`}</li>
      <li parentName="ul">{`Anyone else: Stone M`}</li>
    </ul>
    <p>{`TP to `}<strong parentName="p">{`Sunshade`}</strong>{`. Get `}<strong parentName="p">{`Apothecary Shrine`}</strong>{`, go to `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ophilia-ch2"
    }}>{`Ophilia Ch.2`}</h3>
    <p>{`Get `}<strong parentName="p">{`Copper-filled Pouch`}</strong>{` in Deryl’s house. Get `}<strong parentName="p">{`$3500`}</strong>{` in red chest near the save point on the way to Murkwood, kill encounter with Blizzard x2. Kill encounter in Murkwood with Wind L. If no tree Lightning Blast x3 kills too.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Donate BP + Hired Help, `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold Trap + Arrowstorm`}</li>
        <li parentName="ul">{`Therion: Shackle Foe + Armor Corrosive, `}<strong parentName="li">{`Dancer`}</strong>{`,  Peacock Strut, Mole Dance`}</li>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Merchant`}</strong>{`, Donate BP + Hired Help`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "hrodvitnir"
    }}>{`Hrodvitnir`}</h4>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Tressa: Attack`}</li>
      <li parentName="ul">{`Therion: `}<strong parentName="li">{`Sword`}</strong>{` 2x`}</li>
      <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Spear`}</strong></li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Lightning Blast`}</li>
      <li parentName="ul">{`Tressa/Ophilia: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia/Tressa: HHV x4 + Collect`}</li>
      <li parentName="ul">{`Cyrus: Lightning Blast x4`}</li>
    </ul>
    <p>{`Scrutinize NPC on bridge for New Weapons for Sale (36%).`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-shop-1"
      }}>{`Weapon Shop`}</h5>
      <ul>
        <li parentName="ul">{`2 Elemental Shield for `}<strong parentName="li">{`Therion, Ophilia`}</strong></li>
        <li parentName="ul">{`7 Empowering Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <p>{`Equip one `}<strong parentName="p">{`Empowering Bracelet`}</strong>{` to Cyrus and two to everyone else`}</p>
      <p><em parentName="p">{`Heal Wounds`}</em></p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ophilia-ch3"
    }}>{`Ophilia Ch.3`}</h3>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`, pick `}<strong parentName="p">{`$4500`}</strong>{`, pick `}<strong parentName="p">{`Pom M`}</strong>{` and get the `}<strong parentName="p">{`Wind L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After guiding NPC to cathedral, TP `}<strong parentName="p">{`Quarrycrest`}</strong>{` `}</p>
    <p>{`Get `}<strong parentName="p">{`Thief Shrine`}</strong>{`, get `}<strong parentName="p">{`Pom S`}</strong>{` from the chest. Go to the next area and `}<strong parentName="p">{`S+Q`}</strong>{` at savepoint, tag `}<strong parentName="p">{`Orewell`}</strong>{`, and tag `}<strong parentName="p">{`Riverford`}</strong>{`. TP back to `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <p>{`Can pick `}<strong parentName="p">{`Thunder M`}</strong>{` by the tavern. Head to Seaside Grotto.`}</p>
    <p>{`If you get an encounter before the grotto, kill the encounter with Lightning Blast x2/3 + and a soulstone L/M.  You can S&Q to skip encounter inside Seaside Grotto if you kill this encounter.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Mash cutscene in front of the cave instead of holding to skip, you can immediately start moving as the screen fades in.`}</p>
    </blockquote>
    <p>{`Enter Grotto, kill encounter with any L + Lightning Blast x2 (only use Light L on cultists).`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you had to restore reputation in Saintsbridge, pick `}<strong parentName="p">{`Silver-Filled Pouch`}</strong>{` before boss.`}</p>
    </blockquote>
    <h4 {...{
      "id": "mystery-man--shady-figure"
    }}>{`Mystery Man & Shady Figure`}</h4>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Pom M Ophilia`}</li>
      <li parentName="ul">{`Tressa: Attack MM`}</li>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Therion: 2x Armor Corrosive MM`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: HHBx4`}</li>
      <li parentName="ul">{`Cyrus: Pom M Ophilia`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive SF`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHMx4`}</li>
      <li parentName="ul">{`Cyrus: Lightning Blastx4`}</li>
      <li parentName="ul">{`Ophilia: HHVx4`}</li>
      <li parentName="ul">{`Therion: Peacock/Soulstone M`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`. Scrutinize `}<strong parentName="p">{`Curious Antique (84%)`}</strong>{`. Trigger first cutscene & the cutscene inside the bar for Therion 2. Guide `}<strong parentName="p">{`Aspiring Actor`}</strong>{`, on the stairs near the cemetery. Purchase `}<strong parentName="p">{`Pom Mx2`}</strong>{` from man in the cemetery.`}</p>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <p>{`Head towards Duskbarrow. You can choose to S&Q, or YOLO. If you get battle better to kill it. Tree has about 10k HP.`}</p>
    <p>{`Enter `}<strong parentName="p">{`Duskbarrow`}</strong>{`. Buy `}<strong parentName="p">{`Curious Antique`}</strong>{` by shop, pick `}<strong parentName="p">{`$30000`}</strong>{` in center of town and `}<strong parentName="p">{`Curious Antique`}</strong>{` in top-left corner.`}</p>
    <p>{`TP back to `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Curious Antique`}</strong>{`, trigger first steal cutscene and then finish sidequest: In Search of Father (I) (Talk to Kit)`}</p>
    <p>{`Go to `}<strong parentName="p">{`Forest of Purgation`}</strong>{`. Pick `}<strong parentName="p">{`Light L`}</strong>{` + `}<strong parentName="p">{`Tempest Amulet`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Cat's Eye`}</strong>{`, kill Plains Drakes on the way to `}<strong parentName="p">{`Wispermill`}</strong>{`. 4xLightning Blast + Peacock kills.`}</p>
    <h3 {...{
      "id": "ophilia-ch4"
    }}>{`Ophilia Ch.4`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{` near the shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Adamantite Shield`}</strong>{`, equip to `}<strong parentName="li">{`Tressa`}</strong>{`.`}</li>
        <li parentName="ul">{`11 Healing Grape M`}</li>
        <li parentName="ul">{`11 `}<strong parentName="li">{`Herbs of Clamor`}</strong></li>
      </ul>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Sell all gold items.`}</li>
      </ul>
    </Menu>
    <p>{`Pick `}<strong parentName="p">{`Giant's Club`}</strong>{` and `}<strong parentName="p">{`Adamantite Hat`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-2"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Adamantine Hat`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Apothecary`}</strong>{`, Rehabilitate, Amputation, Empoison, `}<strong parentName="li">{`Merchant`}</strong></li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Apothecary`}</strong></li>
        <li parentName="ul">{`Therion: Mole Dance if not learned earlier`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If enough JP you can teach Ophilia Spearhead + Thousand Spears for Cover for some extra safety vs Mattias.`}</p>
      </blockquote>
      <h5 {...{
        "id": "skills-1"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Any Merchant Skill`}</li>
        <li parentName="ul">{`Ophilia: Heal More, Revive`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Endless Items, Grow on Trees, Heighten Senses`}</li>
        <li parentName="ul">{`Ophilia: Endless Items, Hale & Hearty`}</li>
      </ul>
    </Menu>
    <p>{`Kill encounter with Light L x2 or 1 Light L + any L, and Lightning Blast as needed (will need x3 + Peacock for mushrooms).`}</p>
    <p>{`Pick `}<strong parentName="p">{`30000$`}</strong>{`, save at Mattias (optional)`}</p>
    <h4 {...{
      "id": "cultists"
    }}>{`Cultists`}</h4>
    <h5 {...{
      "id": "turn-1-3"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Pom S self`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Peacock`}</li>
      <li parentName="ul">{`Ophilia: Holy Light`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHM x3 (Bandits to fix range)`}</li>
      <li parentName="ul">{`Cyrus: Lightning Blast x4`}</li>
    </ul>
    <h4 {...{
      "id": "mattias"
    }}>{`Mattias`}</h4>
    <h5 {...{
      "id": "turn-1-4"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Blizzard`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosivex2`}</li>
      <li parentName="ul">{`Ophilia: Pom L self`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-4"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHVx3`}</li>
      <li parentName="ul">{`Cyrus: Pom L Tressa`}</li>
      <li parentName="ul">{`Ophilia: HHVx4`}</li>
      <li parentName="ul">{`Therion: Peacock`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Lighting Blastx4`}</li>
      <li parentName="ul">{`Tressa: HHVx4`}</li>
      <li parentName="ul">{`Ophilia: HHVx3`}</li>
    </ul>
    <p>{`Black Gale hits ~1500`}</p>
    <p>{`If Mattias hits someone twice and they die, use Tressa to prioritize breaking Mattias (use mercenaries instead of vets, olive + heal up to ~1400.  Break on T5 (use sword/blizzard), refresh Armor Corrosive stacks, use BP Donate/ Pom M as needed for vets usage and kill on T6.`}</p>
    <h3 {...{
      "id": "dreisang"
    }}>{`Dreisang`}</h3>
    <p>{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`House Landar Records`}</strong>{` from bottom-left guy downstairs. Go to bottom-left side part of town to guide Whispermill guy.`}</p>
    <p>{`TP `}<strong parentName="p">{`Whispermill`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Nourishing L`}</strong>{` from blonde guy near shop. Scrutinize guy by bar for Commemorative Coin (70%). Complete quest to the top-right by windmill for `}<strong parentName="p">{`$22000`}</strong>{` & pick `}<strong parentName="p">{`Commemorative Coin`}</strong>{` in jail.`}</p>
    <p>{`TP `}<strong parentName="p">{`Riverford`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Complete quest (guy to the right) for `}<strong parentName="p">{`$15000`}</strong>{` + `}<strong parentName="p">{`Revitalizing Jam`}</strong>{`. Buy `}<strong parentName="p">{`Nourishing L`}</strong>{` from guy near right exit.`}</p>
    <p>{`TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 of each herb`}</li>
        <li parentName="ul">{`1 Purifying Dust`}</li>
        <li parentName="ul">{`2 Injurious Dust`}</li>
        <li parentName="ul">{`11 Essence of Grape`}</li>
      </ul>
      <h5 {...{
        "id": "sell-1"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`All Gold Items, `}<strong parentName="li">{`Black Staff`}</strong>{`, `}<strong parentName="li">{`Mattias's Scepter`}</strong></li>
      </ul>
      <p>{`You want to have at least `}<strong parentName="p">{`$108000`}</strong>{` after shop, should normally have $125000.`}</p>
    </Menu>
    <p>{`Talk to orange bubble NPC, buy River Blossom from child, talk to kid above to complete quest for `}<strong parentName="p">{`Badge of Friendship`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Victors Hollow`}</strong>{`, head to `}<strong parentName="p">{`Shrine of the Archmagus`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "inventory"
      }}>{`Inventory`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Nourishing L`}</li>
        <li parentName="ul">{`Tressa: Nourishing L`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-3"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Empowering Bracelet, Wind Amulet`}</li>
        <li parentName="ul">{`Tressa: Tempest Amulet, Badge of Friendship`}</li>
        <li parentName="ul">{`Therion: Empowering Bracelet, Tempest Amulet`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Warrior`}</strong>{`, Thousand Spears`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Cleric`}</strong>{`, 4 Skills, `}<strong parentName="li">{`Merchant`}</strong>{`, Donate BP + Hired Help`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Thief`}</strong>{`, 4 Skills, `}<strong parentName="li">{`Scholar`}</strong></li>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Thief`}</strong>{`, Armor Corrosive`}</li>
      </ul>
      <h5 {...{
        "id": "skill"
      }}>{`Skill`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: +Snatch`}</li>
        <li parentName="ul">{`Therion: Evil Ward, Endless Items, The Show Goes On`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "shrine-of-the-archmagus"
    }}>{`Shrine of the Archmagus`}</h4>
    <p>{`Pick `}<strong parentName="p">{`Pom L`}</strong>{`. Pick `}<strong parentName="p">{`$20000`}</strong>{`. If you get a battle late in the dungeon can pick `}<strong parentName="p">{`Wizard's Rod`}</strong>{` before Dreisang. You want to kill an encounter in here.`}</p>
    <p>{`Heal up. Cyrus needs 70SP (114 for 1 less M Stone strat), Ophilia needs 45SP.`}</p>
    <h4 {...{
      "id": "dreisang-171469hp"
    }}>{`Dreisang 171469HP`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Need 2 M Stones for standard. Can replace 1 with Pom S if turn order allows.`}<br parentName="p"></br>{`
`}{`If Ophilia is before a Merchant T7, you can kill with Pom S Merchant + Cyrus LB that turn.`}<br parentName="p"></br>{`
`}{`You can also do 2 extra Armor Corrosives T1-T4 to always save an M Stone.`}<br parentName="p"></br>{`
`}{`Format is normal strat / M Stone save strat`}</p>
      <p parentName="blockquote">{`Merchant 1 / 2 is based off turn order T2. T3 Merchant 2 reference is based on T2 Merchant turn order.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-5"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Defend / Armor Corrosive`}</li>
      <li parentName="ul">{`Tressa: Spear`}</li>
      <li parentName="ul">{`Therion: Pom M Merchant 1`}</li>
      <li parentName="ul">{`Ophilia: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-5"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Thousand Spears`}</li>
      <li parentName="ul">{`Cyrus: Armor Corrosive x3 / Armor Corrosive x2`}</li>
      <li parentName="ul">{`Merchant 1: HHVx4`}</li>
      <li parentName="ul">{`Merchant 2: Pom L Merchant 1`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`You Pom M whichever Merchant has 3BP at the start of this turn.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-3-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Healing Grape M`}</li>
      <li parentName="ul">{`Tressa: HHVx3`}</li>
      <li parentName="ul">{`Therion: HHVx4`}</li>
      <li parentName="ul">{`Ophilia: Pom M Merchant 2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Lightning Blast`}</li>
      <li parentName="ul">{`Tressa: Collect x4`}</li>
      <li parentName="ul">{`Therion: Defend / Armor Corrosive`}</li>
      <li parentName="ul">{`Ophilia: Heal More x4`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Lightning Blast`}</li>
      <li parentName="ul">{`Tressa: Donate BP Therion`}</li>
      <li parentName="ul">{`Therion: Pom L Tressa`}</li>
      <li parentName="ul">{`Ophilia: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Sword x3`}</li>
      <li parentName="ul">{`Cyrus: Lightning Blast x4`}</li>
      <li parentName="ul">{`Merchants: HHVx4`}</li>
    </ul>
    <h5 {...{
      "id": "turn-7"
    }}>{`Turn 7`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: M Stone / Lightning Blast x2`}</li>
      <li parentName="ul">{`Ophilia: M Stone`}</li>
      <li parentName="ul">{`Merchants: HHVx3`}</li>
    </ul>
    <p>{`If you haven't already, pick `}<strong parentName="p">{`Wizard's Rod`}</strong>{`. TP `}<strong parentName="p">{`Clearbrook`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch1"
    }}>{`Alfyn Ch.1`}</h3>
    <h5 {...{
      "id": "item-shop"
    }}>{`Item Shop`}</h5>
    <p>{`Unequip Ophilia, Replace Ophilia with Alfyn`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-4"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Elemental Augmentor, Unerring Bracelet`}</li>
        <li parentName="ul">{`Tressa: -Tempest Amulet +Empowering Bracelet`}</li>
        <li parentName="ul">{`Therion: -Tempest Amulet +Empowering Bracelet`}</li>
        <li parentName="ul">{`Alfyn: Optimize, Empowering Bracelet x2`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-3"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Sorcerer`}</strong>{`, Lux Congerere + Elemental Break`}</li>
        <li parentName="ul">{`Tressa: 4 Scholar Skills, `}<strong parentName="li">{`Dancer`}</strong>{`, Peacock Strut + Mole Dance`}</li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Warrior`}</strong></li>
      </ul>
      <h5 {...{
        "id": "skills-2"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: -Heightened Senses -Endless Items, +Percipience +The Show Goes On`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Invigorating Nut`}</strong>{` in Caves of Rhiyo is optional now.`}</p>
    </blockquote>
    <h4 {...{
      "id": "blotted-viper-36-sp"
    }}>{`Blotted Viper (36 SP)`}</h4>
    <p>{`Glacies Claudere x4 (Donate BP or Energizing Pomegranate (M/L), might need to kill turn 2)`}<br parentName="p"></br>{`
`}{`OR Glacies x2 + L Stone`}</p>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong></p>
    <h3 {...{
      "id": "alfyn-ch2-start"
    }}>{`Alfyn Ch.2 Start`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Thunder L`}</strong>{` on the beach. Buy `}<strong parentName="p">{`Magic L`}</strong>{` and `}<strong parentName="p">{`Sharp M`}</strong>{` from Lysa.`}<br parentName="p"></br>{`
`}{`Inquire guy in top part of town and TP `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch2-continued"
    }}>{`Cyrus Ch.2 Continued`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Can pick `}<strong parentName="p">{`Pom L`}</strong>{` and/or kill a battle here. Neither is necessary.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`If you don't use the Magic L before Gideon, might need an extra Axe hit or 2 from Alfyn.`}</p>
    </blockquote>
    <h4 {...{
      "id": "gideon-92-sp"
    }}>{`Gideon (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-6"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Elemental Breakx2`}</li>
      <li parentName="ul">{`Tressa: Peacock Cyrus`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Alfyn: Attack Gideon`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-6"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Ignis Ardere x4`}</li>
      <li parentName="ul">{`Tressa/Therion: Donate BP x3 Cyrus`}</li>
      <li parentName="ul">{`Alfyn: Attack Gideon`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-4"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Lux Congerere x4`}</li>
    </ul>
    <p>{`Steal `}<strong parentName="p">{`Fortifying M`}</strong>{` from woman near item shop on the way out (80%)`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h4 {...{
      "id": "therion-ch2-continued"
    }}>{`Therion Ch.2 Continued`}</h4>
    <blockquote>
      <p parentName="blockquote">{`For Steorra through Balogar you will need 2-5 Curious Blooms. You get 3 from steals purchases before then, and there's 1 backup in Clearbrook you can get post Alfyn 4.`}</p>
    </blockquote>
    <p>{`Steal `}<strong parentName="p">{`Curious Bloom (80%)`}</strong>{` and optionally `}<strong parentName="p">{`Heavy Coin Pouch`}</strong>{` from man standing to the left of Oasis Water guy. Steal `}<strong parentName="p">{`Pom S & Invigorating Nut (M) (80%)`}</strong>{` from man standing near Wyvern Scale guy. After stealing `}<strong parentName="p">{`Wyvern Scale`}</strong>{` TP `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch2-start"
    }}>{`Tressa Ch.2 Start`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Curious Bloom (80%)`}</strong>{` and optionally `}<strong parentName="p">{`Injurious Dust`}</strong>{` from man on the upper screen near the bar. Steal `}<strong parentName="p">{`Thunder M (100%) and L (65/80%)`}</strong>{` from man near the stairs on lower screen. Pick `}<strong parentName="p">{`Fool's Gold Ore`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You can buy a Fire M or Light M off the 2nd guy for Venomtooth Tiger guaranteed Collect.`}</p>
    </blockquote>
    <p>{`After the three purchases, TP to `}<strong parentName="p">{`Stillsnow`}</strong>{` and head for `}<strong parentName="p">{`Northreach`}</strong>{`. Kill encounter with 2xBandits + 3xIgnis/4xLightning Blast (or L Stone).`}</p>
    <h4 {...{
      "id": "northreach"
    }}>{`Northreach`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Need $26200 for essentials, $34300 for Gold Items.`}</p>
    </blockquote>
    <p>{`Purchase `}<strong parentName="p">{`Empowering Necklace`}</strong>{` from man by the entrance. Purchase `}<strong parentName="p">{`Resistant L, Fool's Gold Ore, Curious Antique`}</strong>{` from man standing to the left of the items shop. Purchase `}<strong parentName="p">{`Magic L`}</strong>{` from Angela.`}</p>
    <p>{`TP `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <h4 {...{
      "id": "tressa-ch2-continued"
    }}>{`Tressa Ch.2 Continued`}</h4>
    <p>{`Steal `}<strong parentName="p">{`Fool's Gold Ore x2 (100%)`}</strong>{` from woman standing in front of house.`}</p>
    <p>{`Kill battle inside Manse. Pick `}<strong parentName="p">{`Hasty Helm`}</strong>{` inside the second door you run past on the second screen of Morlock's Manse.`}</p>
    <p>{`If you need to restore SP, use nuts & do the next menu further down.`}</p>
    <h4 {...{
      "id": "omar-6478-sp"
    }}>{`Omar (64/78 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-7"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Elemental Break x2`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Cyrus`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-7"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Donate BPx3`}</li>
      <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Spear`}</strong>{` x3`}</li>
      <li parentName="ul">{`Cyrus: Blizzard x4`}</li>
      <li parentName="ul">{`Tressa: Donate BP x3`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-5"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Lightning Blast x4 / Ignis x3`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong></p>
    <h3 {...{
      "id": "tressa-ch3-start"
    }}>{`Tressa Ch.3 Start`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Curious Bloom (80%)`}</strong>{` from woman near the item shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-2"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`21 Inspiriting Plums`}</li>
        <li parentName="ul">{`11 Injurious Seeds`}</li>
        <li parentName="ul">{`2 Herbs of Healing`}</li>
      </ul>
      <h5 {...{
        "id": "sell-2"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Gold items`}</li>
        <li parentName="ul">{`Omar's Axe`}</li>
        <li parentName="ul">{`Wizard's Rod`}</li>
      </ul>
    </Menu>
    <p>{`Goal is $60,000.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Edbert's Shield`}</strong>{` and TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch2-continued-2-electric-boogaloo"
    }}>{`Therion Ch.2 Continued 2: Electric Boogaloo`}</h3>
    <p>{`Whenever you need to restore SP, use nuts and do this menu. Needs to be done by Orlick.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "inventory-1"
      }}>{`Inventory`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Magic L, Invigorating S, Invigorating M, Sharp M`}</li>
        <li parentName="ul">{`Tressa: Resistant L`}</li>
        <li parentName="ul">{`Therion: Fortifying M, Fortifying L`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Rehabilitate + Amputation + Empoison, Incite + Thousand Spears`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Cover, Hale & Hearty`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "orlick-92-sp"
    }}>{`Orlick (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-8"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Elemental Breakx2`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Cyrus`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Alfyn: Attack Orlick`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-8"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Cyrus: Ignis x4`}</li>
      <li parentName="ul">{`Tressa/Therion: Donate BP x3 Cyrus`}</li>
      <li parentName="ul">{`Alfyn: Attack Orlick`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-6"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Cyrus: Lux Congerere x4`}</li>
    </ul>
    <p>{`Tag `}<strong parentName="p">{`S’warkii`}</strong>{` and teleport to `}<strong parentName="p">{`Victor's Hollow`}</strong></p>
    <h3 {...{
      "id": "tressa-ch3-continued"
    }}>{`Tressa Ch.3 Continued`}</h3>
    <p><em parentName="p">{`Optional: Pick `}<strong parentName="em">{`Pom L`}</strong>{` after 6th torch.`}</em><br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$15000`}</strong>{` (red chest off to the right).`}</p>
    <h4 {...{
      "id": "venomtooth-tiger-92-sp"
    }}>{`Venomtooth Tiger (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-9"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Ignis Ardere`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Cyrus`}</li>
      <li parentName="ul">{`Therion: Bow / Fire M / Light M (M Stone makes Collect 100%).`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-9"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Injurious Seed + Noxroot / Thousand Spears if Therion missed.`}</li>
      <li parentName="ul">{`Cyrus: Elemental Break`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-7"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Collect x4 (99%)`}</li>
      <li parentName="ul">{`Cyrus: Ignis Ardere x4`}</li>
      <li parentName="ul">{`Therion: HHVx4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Grandport`}</strong></p>
    <h3 {...{
      "id": "tressa-ch4"
    }}>{`Tressa Ch.4`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Lapis Lazuli`}</strong>{` from man in blue hat near the entrance (should have $58,000 left over).`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`L Stones`}</strong>{` from merchant in Bazaar.`}</p>
    <p>{`Enter bottom left screen, pick `}<strong parentName="p">{`Force Shield`}</strong>{`, go back to previous screen and pick `}<strong parentName="p">{`Wind L`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-5"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Force Shield`}</li>
        <li parentName="ul">{`Alfyn: -Empowering Bracelet +Empowering Necklace`}</li>
      </ul>
      <p><em parentName="p">{`Heal up`}</em>{`.`}</p>
    </Menu>
    <h4 {...{
      "id": "esmeralda-92-sp"
    }}>{`Esmeralda (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-10"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Elemental Break x2`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Cyrus`}</li>
      <li parentName="ul">{`Therion: Pom L Cyrus`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-10"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Thousand Spears`}</li>
      <li parentName="ul">{`Cyrus: Ignis Ardere x4`}</li>
      <li parentName="ul">{`Tressa: Pom M Cyrus / Donate BP if acting before him`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-8"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Ignis Ardere x3-4`}</li>
      <li parentName="ul">{`Tressa/Therion: HHVx4`}</li>
      <li parentName="ul">{`Alfyn: Amputation x4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Phase 2 weaknesses are Sword, Bow, Fire, Lightning, Wind`}</p>
    </blockquote>
    <p>{`Watch Cyrus JP. If over 4k can learn Elemental Aid early and 2T Vanessa.`}</p>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch2"
    }}>{`Alfyn Ch.2`}</h3>
    <Menu mdxType="Menu">
      <p>{`If you don't have enough JP for Elemental Aid, you can delay this till after Vanessa.`}<br parentName="p"></br>{`
`}{`Note that if you skipping the Invigorating S in Alfyn 1, delay the Stimulating Bracelet, and level up off Vanessa, Cyrus will be 163SP, which is 1 short for Yvon fight.`}</p>
      <h5 {...{
        "id": "equipment-6"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: -Unerring Bracelet, +Stimulating Bracelet`}</li>
      </ul>
      <p><em parentName="p">{`If 4000 JP`}</em></p>
      <h5 {...{
        "id": "skills-3"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Tonitrus Canere + Ventus Saltare`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills-1"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Stronger Strikes, Elemental Aid`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "vanessa-72-sp"
    }}>{`Vanessa (72 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-11"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Elemental Break x2`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Cyrus`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-11"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Donate BP x3 Cyrus`}</li>
      <li parentName="ul">{`Cyrus: Glacies Claudere x4`}</li>
      <li parentName="ul">{`Tressa: Donate BP x3 Cyrus`}</li>
      <li parentName="ul">{`Alfyn: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-9"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Ignis Ardere x4`}</li>
    </ul>
    <hr></hr>
    <h4 {...{
      "id": "2t-with-elemental-aid-144sp"
    }}>{`2T with Elemental Aid. (144SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Adjust fight based on person before Cyrus.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-12"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Glacies x2 / x3 if Therion first / x4 if Alfyn first. Can do standard x2 if Tressa before Cyrus.`}</li>
      <li parentName="ul">{`Tressa: Peacock Cyrus`}</li>
      <li parentName="ul">{`Therion: Defend / Donate BPx2 if first`}</li>
      <li parentName="ul">{`Alfyn: Pom M if first / L Stone if Cyrus was first / Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-12"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Ignis x4`}</li>
      <li parentName="ul">{`Therion: Donate BPx3`}</li>
      <li parentName="ul"><em parentName="li">{`Depending on fight might need an M Stone or Alfyn attack (range)`}</em></li>
    </ul>
    <p>{`Go to `}<strong parentName="p">{`Moonstruck Coast`}</strong>{`. Steal `}<strong parentName="p">{`Primeval Robe (100%)`}</strong>{` from woman near the tent. Complete Sidequest: In Search of Father (II) (Talk to Kit). TP `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch3"
    }}>{`Cyrus Ch.3`}</h3>
    <p><em parentName="p">{`If not done earlier, teach Cyrus Sorcerer skills + Elemental Aid.`}</em></p>
    <p>{`Steal `}<strong parentName="p">{`Injurious Dust & Fire L (80%)`}</strong>{` from Tobias. `}<em parentName="p">{`Quiz: Option 3, Option 3.`}</em><br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Light L, Shadow L (80%)`}</strong>{`, and if possible `}<strong parentName="p">{`Unerring Bracelet (65%)`}</strong>{` from man to the left of the fountain in Stonegard Heights.`}</p>
    <h4 {...{
      "id": "yvon-164-sp"
    }}>{`Yvon (164 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-13"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Elemental Break x2`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Cyrus`}</li>
      <li parentName="ul">{`Therion: Pom M Cyrus`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-13"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Injurious Seed + Addlewort`}</li>
      <li parentName="ul">{`Cyrus: Tonitrus Canere x3`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Donate BPx3 Cyrus`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-10"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Collect x4`}</li>
      <li parentName="ul">{`Therion: M Stone / Armor Corrosive if before Alfyn`}</li>
      <li parentName="ul">{`Cyrus: Ignis Ardere x4`}</li>
      <li parentName="ul">{`Alfyn: Amputation x4`}</li>
    </ul>
    <h3 {...{
      "id": "therion-ch3"
    }}>{`Therion Ch.3`}</h3>
    <p>{`Kill mandatory mob with Fireball x2`}</p>
    <h4 {...{
      "id": "gareth-116-sp"
    }}>{`Gareth (116 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-14"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Cyrus`}</li>
      <li parentName="ul">{`Therion: Donate BP Cyrus`}</li>
      <li parentName="ul">{`Alfyn: Injurious Seed + Essence of Grape`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-14"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Glacies Claudere x4`}</li>
      <li parentName="ul">{`Tressa: Donate BP x3 to Cyrus`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-11"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Lightning Blast x4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch3-start"
    }}>{`Alfyn Ch.3 Start`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Pom M`}</strong>{` after cutscene. Steal `}<strong parentName="p">{`Poms`}</strong>{` from guy by screen transition.`}</p>
    <p>{`After inquiring by Tavern, `}<strong parentName="p">{`go to church & purchase Battle-Tested Staff.`}</strong></p>
    <p>{`TP `}<strong parentName="p">{`Wispermill`}</strong>{` and go to `}<strong parentName="p">{`Shrine of the Starseer`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Note: If you have enough money for Empowering Necklace before Steorra, you can buy that early and do the Alfyn 3 equip menu combined with this one.`}</p>
      </blockquote>
      <h5 {...{
        "id": "equipment-7"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Battle-Tested Staff`}</li>
        <li parentName="ul">{`Therion: Gideon's Dagger, Hasty Helm, Primeval Robe`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-4"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Tenebrae Operire`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Hunter`}</strong></li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Cleric`}</strong>{`, All Cleric skills`}</li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Dancer`}</strong>{`, Peacock Strut + Mole Dance`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills-2"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Augmented Elements`}</li>
        <li parentName="ul">{`Therion: Saving Grace`}</li>
        <li parentName="ul">{`Alfyn: The Show Goes On`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "steorra-starseer-144-sp"
    }}>{`Steorra, Starseer (144 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`This turn is kind of hard to explain, so I'll just list the goals of the turn.`}</p>
      <ol parentName="blockquote">
        <li parentName="ol">{`Get Leghold up. This can be done through Leghold or Injurious Dust + Curious Bloom, which also breaks a shield.`}</li>
        <li parentName="ol">{`Heal / prevent status. Anyone can heal with Herb of Clarity, Alfyn can prevent with Soothing dust + Curious bloom.`}</li>
        <li parentName="ol">{`Set up turn 2 Aelfics. You need to Pom Therion & defend with him if he's before Cyrus. Worst case, you can Soothing Seed + Curious Bloom Therion to put him before Cyrus.`}</li>
        <li parentName="ol">{`Break 1 shield off Steorra. Can be done with any character that has a free turn. This can also be done next turn.`}</li>
      </ol>
      <p parentName="blockquote">{`Despite all this text, this fight is pretty easy. You generally have multiple free turns. Just need to get a feel for it.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-15"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Heal status / Pom S Therion / Fireball`}</li>
      <li parentName="ul">{`Tressa: Heal status / Leghold / Donate BP Therion`}</li>
      <li parentName="ul">{`Therion: Defend / Heal status / Pom S self`}</li>
      <li parentName="ul">{`Alfyn: Soothing Dust + Curious Bloom / Heal Status / Injurious Dust + Curious Bloom`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Take note of whether or not Alfyn Peacocks Cyrus before Cyrus does Ignis`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-15"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aelfics Cyrus`}</li>
      <li parentName="ul">{`Cyrus: Ignis Ardere`}</li>
      <li parentName="ul">{`Tressa: Mercenaries if you need to break shield / Grape M`}</li>
      <li parentName="ul">{`Alfyn: Peacock Strut x2 Cyrus`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Revitilizing Jam has to be after Cyrus's turn. If Cyrus is last, have Therion defend and use it T4. Therion's turn is the least valuable T4.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-3-12"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Ignis Ardere x4`}</li>
      <li parentName="ul">{`Tressa: Collect x4`}</li>
      <li parentName="ul">{`Therion: Grape M if not done already / Revitalizing Jam Cyrus / Defend`}</li>
      <li parentName="ul">{`Alfyn: Grape M if not done already / Revitalizing Jam Cyrus / Defend`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Fight changes depending on amount of shield on Steorra. 4S is free, 8S is slightly harder, 12S is the worst one.`}<br parentName="p"></br>{`
`}{`You need someone between Cyrus T4 and T5 to give him 1 BP. Should always be possible with 4 & 8 shields, and possible most of the time with 12 shields.`}<br parentName="p"></br>{`
`}{`If you need to use Revitilizing Jam, try to use it with Therion.`}<br parentName="p"></br>{`
`}{`If you get 12S, someone needs to be able to give Cyrus 1BP between his turns T4 and T5. If not, you need an extra 2 L Stones + Amputation to kill. In this case, you might just want to have Tressa Leghold T4, finish break T5, and finish T6 with a Lightning Blast or something.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-4-1"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Pay attention to number of shields Steorra has left`}</strong></li>
      <li parentName="ul">{`Cyrus: Tenebrae x4 (4), Tonitrus x4 (8), Ignis x4 (12)`}</li>
      <li parentName="ul">{`Tressa: Defend / Donate BP (4/8), Rain of Arrows (12)`}</li>
      <li parentName="ul">{`Alfyn: Rev Jam if needed / Injurious Seed + Plum (8), Injurious Seed + Curious Bloom (12) / Defend`}</li>
      <li parentName="ul">{`Therion: Rev Jam if needed / Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-1"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Ignis x4`}</li>
      <li parentName="ul">{`Alfyn: Amputation x4 (if 8 or 12 shield & no peacock before Cyrus's turn T2)`}</li>
      <li parentName="ul">{`Rest: Pom S Cyrus if needed.`}</li>
    </ul>
    <hr></hr>
    <p>{`TP `}<strong parentName="p">{`Wispermill`}</strong>{`. Leave town & purchase `}<strong parentName="p">{`Empowering Necklace`}</strong>{` from the guy farther south.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Saintsbridge`}</strong></p>
    <h4 {...{
      "id": "alfyn-ch3-continued"
    }}>{`Alfyn Ch.3 Continued`}</h4>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Try to do this on the 2nd screen so you have an Autosave if you mess up.`}</p>
      </blockquote>
      <h5 {...{
        "id": "equipment-8"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: -Badge of Friendship +Empowering Bracelet`}</li>
        <li parentName="ul">{`Therion: -Empowering Bracelet +Empowering Necklace`}</li>
        <li parentName="ul">{`Alfyn: -Empowering Necklace +Badge of Friendship`}</li>
        <li parentName="ul">{`Cyrus: -Stimulating Bracelet +Empowering Necklace`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-5"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Dancer`}</strong></li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Starseer`}</strong>{`, 3 Skills, `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold Trap`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills-3"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: +Hard Worker`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "miguel-144-sp"
    }}>{`Miguel (144 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-16"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Elemental Break`}</li>
      <li parentName="ul">{`Tressa: Peacock`}</li>
      <li parentName="ul">{`Therion: Defend / Pom S `}<strong parentName="li">{`Self`}</strong>{` if before Cyrus T2`}</li>
      <li parentName="ul">{`Alfyn: Pom S `}<strong parentName="li">{`Therion`}</strong>{` / Leghold Trap if Therion & Miguel before Cyrus T2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-16"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aelfics Cyrus`}</li>
      <li parentName="ul">{`Cyrus: 3xVentus`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Orewell`}</strong></p>
    <h3 {...{
      "id": "alfyn-ch4"
    }}>{`Alfyn Ch.4`}</h3>
    <p>{`Two one-text-box cutscenes, press A instead of skipping to immediately gain control afterwards.`}</p>
    <h4 {...{
      "id": "ogre-eagle-164-sp"
    }}>{`Ogre Eagle (164 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`There's lots of ways to get little bonuses here. I recommend playing with this fight to get a feel for it.`}<br parentName="p"></br>{`
`}{`Assuming min damage, you need an L Stone + an Amputation x4 / M Stone to kill. With Summon Strengh on Alfyn, you can kill with Amputation x4 + M Stone but you'd have to give up The Show Goes On which gives you status immunity T2 with Curious Mist T1.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-17"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Pom S/M Therion / can Elemental Break if Therion before Cyrus`}</li>
      <li parentName="ul">{`Tressa: Peacock Cyrus`}</li>
      <li parentName="ul">{`Therion: Defend / Pom S Self / Aelfics if some had a turn to Pom M him before his turn.`}</li>
      <li parentName="ul">{`Alfyn: Soothing Dust + Curious Bloom / heal status if someone is statused with something bad / Injurious Dust + Curious Bloom or Leghold no status heal needed & Eagle before Cyrus T2 / Pom M Cyrus or Icicle`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-17"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aelfics Cyrus`}</li>
      <li parentName="ul">{`Cyrus: Glacies x3`}</li>
      <li parentName="ul">{`Tressa: Donate BP Cyrus / Defend if last next turn or she's after Cyrus T3 and Ignis will kill next turn.`}</li>
      <li parentName="ul">{`Alfyn: Pom M Cyrus / Pom L if Tressa can't Donate BP`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-13"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Collect x4`}</li>
      <li parentName="ul">{`Cyrus: Ignis Ardere x4`}</li>
      <li parentName="ul">{`Therion: L Stone`}</li>
      <li parentName="ul">{`Alfyn: Amputation x4`}</li>
    </ul>
    <p>{`If you're short `}<strong parentName="p">{`Curious Blooms`}</strong>{`, steal 1 from the guy by Clearbrook tavern.`}</p>
    <p>{`TP `}<strong parentName="p">{`Riverford`}</strong>{`, go to `}<strong parentName="p">{`Shrine of the Warbringer`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`$30000`}</strong>{`, optionally can pick `}<strong parentName="p">{`Revitalizing Jam`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-6"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Warrior`}</strong>{`, All Warrior Skills, `}<strong parentName="li">{`Sorcerer`}</strong></li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Scholar`}</strong>{`, All Scholar Skills`}</li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Dancer`}</strong></li>
      </ul>
      <h5 {...{
        "id": "support-skills-4"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: -Evasive Maneuvers, +Surpassing Power`}</li>
        <li parentName="ul">{`Tressa: -Snatch, +Evasive Maneuvers`}</li>
      </ul>
      <p>{`Heal HP and Cyrus SP`}</p>
    </Menu>
    <h4 {...{
      "id": "winnehild-warbringer-164sp"
    }}>{`Winnehild, Warbringer (164SP)`}</h4>
    <h5 {...{
      "id": "turn-1-18"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Glacies`}</li>
      <li parentName="ul">{`Tressa: HHM / Heal / Herb of Healing`}</li>
      <li parentName="ul">{`Therion: Shackle Foe / Heal / Herb of Healing`}</li>
      <li parentName="ul">{`Alfyn: Injurious Dust + Curious Bloom`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If Therion, Tressa, or Alfyn is before Cyrus T2 and T3, you can break Winnehild with them to guarantee that Elemental Break doesn't miss.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-18"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Elemental Break`}</li>
      <li parentName="ul">{`Tressa: Defemd`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Alfyn: Peacock Cyrus`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-14"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aelfric’s Cyrus`}</li>
      <li parentName="ul">{`Tressa: Alephan's Cyrus`}</li>
      <li parentName="ul">{`Cyrus: Ignis x4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Everhold`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`Shadow L`}</strong>{` and `}<strong parentName="p">{`Sorcerer's Robe`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-7"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Starseer`}</strong>{`, 3 Skills, `}<strong parentName="li">{`Cleric`}</strong></li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Warmaster`}</strong>{`, 2 Skills, `}<strong parentName="li">{`Dancer`}</strong></li>
      </ul>
      <h5 {...{
        "id": "support-skills-5"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Therion: -Endless Items -Saving Grace +Boost-Start +Hard Worker`}</li>
        <li parentName="ul">{`Alfyn: -Hard Worker +Extra Experience`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Shrine of the Runeblade`}</strong>{`. Everhold encounter Ignis x2. If Tressa first you can break with Dancer x2.`}</p>
    <h4 {...{
      "id": "balogar-the-runeblade-164-sp"
    }}>{`Balogar, The Runeblade (164 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-19"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Elemental Break x2`}</li>
      <li parentName="ul">{`Tressa: Pom M Cyrus`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Aflyn: Injurious Dust + Curious Bloom`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-19"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aelfics`}</li>
      <li parentName="ul">{`Cyrus: Tenebrae Operire`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Alfyn: Peacock x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-15"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephans`}</li>
      <li parentName="ul">{`Cyrus: Ignis x4`}</li>
    </ul>
    <hr></hr>
    <h4 {...{
      "id": "elemental-break-miss-backup"
    }}>{`Elemental Break Miss Backup`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Only need to heal someone if they're not in Cover range or it's Alfyn that got hit.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-3-16"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephans`}</li>
      <li parentName="ul">{`Cyrus: Ignis x4`}</li>
      <li parentName="ul">{`Therion: Pom M Cyrus / Heal / Plum M Cyrus`}</li>
      <li parentName="ul">{`Alfyn: Defend / Pom M Cyrus / Plum M Cyrus`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-2"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Tenebrae x2 / Defend and Tenebrae x2 next turn`}</li>
      <li parentName="ul">{`Tressa: Plum M / Pom M / Collect`}</li>
      <li parentName="ul">{`Therion: Plum M / Pom M`}</li>
      <li parentName="ul">{`Alfyn: Rehabilitate Cyrus if he got statused.`}</li>
    </ul>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`If you skipped Collect on Ogre Eagle, pick `}<strong parentName="p">{`$50000`}</strong>{` chest.`}</p>
    </blockquote>
    <p>{`TP `}<strong parentName="p">{`Cobbleston`}</strong>{`.`}</p>
    <h1 style={{
      color: 'red',
      fontSize: '72px'
    }}>Olberic Ch.1</h1>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-9"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: (ALL OPTIONAL) Knowledge Staff, -Empowering Necklace +Stimulating Bracelet`}</li>
        <li parentName="ul">{`Alfyn: Unequip All`}</li>
      </ul>
    </Menu>
    <p>{`Replace Alfyn with Olberic`}</p>
    <p>{`Mandatory fight: Cyrus Fireball x1 / Tressa Lightning Blast x2 / Therion Luminescence x2 / M Stone`}</p>
    <h4 {...{
      "id": "gaston-44-sp"
    }}>{`Gaston (44 SP)`}</h4>
    <p>{`Cyrus: Lightning Blast x2`}</p>
    <p>{`TP to `}<strong parentName="p">{`Victor’s Hollow`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-10"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: BT Staff, Stimulating Bracelet if not on already`}</li>
        <li parentName="ul">{`Tressa: Optimize, -2 Bracelet +Badge of Friendship +Empowering Necklace`}</li>
        <li parentName="ul">{`Olberic: Optimize, Empowering Bracelet x2`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-8"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Dancer`}</strong></li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Warmaster`}</strong>{`, 2 Skills, `}<strong parentName="li">{`Cleric`}</strong></li>
        <li parentName="ul">{`Olberic: `}<strong parentName="li">{`Merchant`}</strong>{`, Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills-6"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Therion: -The Show Goes On, +Extra Experience`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "olberic-ch2"
    }}>{`Olberic Ch.2`}</h3>
    <p>{`Challenges: HHV`}</p>
    <p>{`Victorino: Ventus x3 or Ventus x2 + L Stone or Ignis x4`}</p>
    <p>{`Joshua: Lux x4 or Lux x3 + Peacock`}<br parentName="p"></br>{`
`}{`Archibold: Tenebrae x4 or Tenebrae x3 + Peacock`}</p>
    <h4 {...{
      "id": "gustav"
    }}>{`Gustav`}</h4>
    <blockquote>
      <p parentName="blockquote">{`If you get Peacock + a Pom L before Cyrus T1, you can kill with Ignis x3 & Ignis x4`}<br parentName="p"></br>{`
`}{`If you get one of them, a 2xIgnis with Peacock or a 3xIgnis + 4xIgnis + Fire M kills`}<br parentName="p"></br>{`
`}{`If you get Cyrus first, it would take an extra L + M Stone at least. The L might need to be Fire or Shadow. I recommend just reverting to Aelfics in this scenario.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-20"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Glacies Claudere x2 / Ignis x3`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Cyrus`}</li>
      <li parentName="ul">{`Therion/Olberic: Pom L Cyrus`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-20"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Ignis Ardere x4`}</li>
      <li parentName="ul"><em parentName="li">{`Aelfics/Fire M if necessary`}</em></li>
    </ul>
    <p>{`TP to `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <h3 {...{
      "id": "olberic-ch3"
    }}>{`Olberic Ch.3`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-11"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Knowledge Staff`}</li>
        <li parentName="ul">{`Therion: Optimize, remove Gideon's Dagger`}</li>
        <li parentName="ul">{`Olberic: Unequip all`}</li>
      </ul>
    </Menu>
    <p>{`88 SP Cyrus, 1st Fight dies to Icewind (range) & second to Blizzard`}</p>
    <h4 {...{
      "id": "lizardman-chief-116-sp"
    }}>{`Lizardman Chief (116 SP)`}</h4>
    <p>{`You want to break Lizardking here for the EXP bonus. This let's Olberic level up off Erhardt which heals him for Red Hat guy. Hence the Attack on Lizardking with Olberic.`}</p>
    <h5 {...{
      "id": "turn-1-21"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Pom S Self`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Cyrus`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Olberic: Attack Lizard King`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-21"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aelfric’s Cyrus`}</li>
      <li parentName="ul">{`Cyrus: Tonitrus Canere x4`}</li>
    </ul>
    <h4 {...{
      "id": "erhardt"
    }}>{`Erhardt`}</h4>
    <ol>
      <li parentName="ol">{`Shadow L`}</li>
      <li parentName="ol">{`Defend`}</li>
      <li parentName="ol">{`HHVx4`}</li>
    </ol>
    <p>{`TP `}<strong parentName="p">{`Riverford`}</strong>{`.`}</p>
    <h3 {...{
      "id": "olberic-ch4"
    }}>{`Olberic Ch.4`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You need 2 Fire/Thunder Ls for H'aanit chapters.`}<br parentName="p"></br>{`
`}{`Scrutinize (80%) & pick the `}<strong parentName="p">{`Fire L`}</strong>{` if needed.`}</p>
    </blockquote>
    <p><strong parentName="p">{`Red Hat`}</strong>{`: Pom L, HHVx4, HHVx3 OR Pom M, Defend, HHVx4, HHVx3`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-9"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Starseer`}</strong>{`, 4 Skills, `}<strong parentName="li">{`Sorcerer`}</strong></li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Starseer`}</strong>{`, 4 Skills, `}<strong parentName="li">{`Scholar`}</strong></li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Starseer`}</strong>{`, 1 Skill, `}<strong parentName="li">{`Cleric`}</strong></li>
        <li parentName="ul">{`Olberic: 3 Merchant Skills, `}<strong parentName="li">{`Warrior`}</strong>{`, 2 Skills, `}<strong parentName="li">{`Thief`}</strong>{`, first 3 Skills`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills-7"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: -Stronger Strikes, Augmented Elements, +Boost Start, BP Eater`}</li>
        <li parentName="ul">{`Tressa: -The Show Goes On, +Boost Start`}</li>
        <li parentName="ul">{`Olberic: Hang Tough, Cover, Fleetfoot`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "werner-144-sp"
    }}>{`Werner (144 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`If someone got terrored delay break until T2 and kill T3.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-22"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Tonitrus`}</li>
      <li parentName="ul">{`Tressa/Therion: Defend`}</li>
      <li parentName="ul">{`Olberic: Dagger x2 / HP Thief if Terrored / Nothing if Cyrus before Werner T2 and no Werner actions left T1`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-22"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephans`}</li>
      <li parentName="ul">{`Therion: Aelfric`}</li>
      <li parentName="ul">{`Cyrus: Ignis Ardere x4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Highly recommend stealing the 55% accessories now, as money is a lot tighter skipping Winnehild Collect.`}</p>
    </blockquote>
    <p>{`Steal/Purchase `}<strong parentName="p">{`Sprightly Necklace (55%)`}</strong>{` from Noelle. TP `}<strong parentName="p">{`Bolderfall`}</strong>{`, go to the manor screen.`}</p>
    <p>{`Steal `}<strong parentName="p">{`Pom L`}</strong>{` from Alphas. Challenge Alphas, use `}<strong parentName="p">{`Fire L or Shadow L`}</strong>{` to complete sidequest: Daughter of the Dark God (I).`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <p>{`Steal/Purchase `}<strong parentName="p">{`Empowering Necklace (55%)`}</strong>{` from Marlene (In the house from Alfyn 2). Scrutinize Bishop Donovan in the cathedral.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <p>{`Purchase `}<strong parentName="p">{`Battle-Tested Blade`}</strong>{` from Erhardt (in the house from Olberic 3). Steal `}<strong parentName="p">{`Light M`}</strong>{` and `}<strong parentName="p">{`Sharp M`}</strong>{` from Bale (100%). Talk to Bale twice to complete sidequest: Back with Bale.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <p>{`Talk to Lyblac near the exit to Rivira Woods and then find Alphas to her right and Scrutinize: Alphas’ Poem.`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`Fortifying L`}</strong>{` and `}<strong parentName="p">{`Light M`}</strong>{` from Tim (child standing to the right of weapon shop).`}</p>
    <blockquote>
      <p parentName="blockquote">{`After purchasing nuts, should have about 51k to afford Double Tomahawk, 61k to afford that + BT Axe later.`}</p>
    </blockquote>
    <p>{`Steal `}<strong parentName="p">{`Shadow M, Shadow L`}</strong>{` from Knight Ardante outside cathedral.`}<br parentName="p"></br>{`
`}{`Talk to woman near the cathedral to complete sidequest: Daughter of the Dark God (II).`}</p>
    <p>{`TP `}<strong parentName="p">{`S’warkii`}</strong>{`.`}</p>
    <h3 {...{
      "id": "haanit-ch1"
    }}>{`H'aanit Ch.1`}</h3>
    <p>{`Replace Olberic with H'aanit`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-12"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`H'aanit: Optimize, Empowering Bracelet, Empowering Necklace, `}<strong parentName="li">{`Lizardking’s Axe`}</strong></li>
        <li parentName="ul">{`Therion: -Empowering Bracelet, +Captain’s Badge`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "ghisarma-44-sp"
    }}>{`Ghisarma (44 SP)`}</h4>
    <p>{`Cyrus Lightning Blast x3`}</p>
    <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong></p>
    <h3 {...{
      "id": "haanit-ch2"
    }}>{`H'aanit Ch.2`}</h3>
    <p>{`Nathan’s Bodyguard: Fire/Thunder L x2, M Stone`}</p>
    <p>{`Purchase `}<strong parentName="p">{`Double Tomahawk`}</strong>{` from Archibold (all the way to the right in Stonegard Valley)`}</p>
    <blockquote>
      <p parentName="blockquote">{`Need to have about 10000$ after / $73000 before Double Tomahawk purchase to have enough for `}<strong parentName="p">{`Battle-Tested Axe`}</strong>{`. If short, you can either replace Tomahawk purchase with Ogen quest or sell stuff post H'aanit 4.`}</p>
    </blockquote>
    <p>{`Ancient One: Thunder/Fire/Light L, Any L`}</p>
    <blockquote>
      <p parentName="blockquote">{`Can learn Leghold + Arrowstorm on H'aanit here for potential Lord of the Forest / Redeye shenanigans`}</p>
    </blockquote>
    <h4 {...{
      "id": "lord-of-the-forest-92-sp"
    }}>{`Lord Of The Forest (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-23"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Elemental Break`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`H'aanit: Can use Leghold Trap on Lord of the Forest`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-23"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephan’s Cyrus`}</li>
      <li parentName="ul">{`Cyrus: Ignis Ardere x4`}</li>
    </ul>
    <p>{`Steal `}<strong parentName="p">{`Fortifying M (100%)`}</strong>{` from NPC before screen split to lower area. TP to `}<strong parentName="p">{`Stillsnow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "haanit-ch3"
    }}>{`H'aanit Ch.3`}</h3>
    <p>{`Alaic: Fox, 2 Shadow L, any L OR Fox, Shadow M, Shadow L, Thunder L w/ Lizardking Axe`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-13"
      }}>{`Equipment`}</h5>
      <p>{`H'aanit: Double Tomahawk`}</p>
    </Menu>
    <h4 {...{
      "id": "dragon-92-sp"
    }}>{`Dragon (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-24"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Elemental Break`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`H’aanit: Axe x2 (4 hits)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-24"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephan’s Cyrus`}</li>
      <li parentName="ul">{`Cyrus: Lightning Blast x4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`To skip H’aanit 4 & Prim 3 Battle & get LVL45 Therion he needs to be LVL40 2635EXP after Dragon`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`If you're short on cash, you can sell Lizardking Axe, Divine Blade, Rune Knife, and all your Refreshing Jams a bit over 40k.`}</p>
    </blockquote>
    <p>{`TP `}<strong parentName="p">{`Marsalim`}</strong>{`.`}</p>
    <h3 {...{
      "id": "haanit-ch4"
    }}>{`H'aanit Ch.4`}</h3>
    <p>{`Steal `}<strong parentName="p">{`2 Pom L`}</strong>{` from man standing by weapon shop.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If short on money, can sell weapons in the weapon shop here. Rune Knife, Divine Blade, Lizardking Axe sell for about 30k. Can also sell all Refreshing Jams for about 15k.`}</p>
    </blockquote>
    <h4 {...{
      "id": "redeye-144-sp"
    }}>{`Redeye (144 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Can go for T1 break with Ignis + 2xBow/Rain of Arrows. Tressa can Firestorm & Therion can attack if they're before Cyrus T2.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-25"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Staff x1`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`H'aanit: Defend`}</li>
      <li parentName="ul"><em parentName="li">{`If H'aanit is blinded, use Herb of Light on her if turn order allows.`}</em></li>
    </ul>
    <h5 {...{
      "id": "turn-2-25"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephan’s Cyrus`}</li>
      <li parentName="ul">{`Therion: Aelfric’s Cyrus`}</li>
      <li parentName="ul">{`H'aanit: Axe x3`}</li>
      <li parentName="ul">{`Cyrus: Ignis Ardere x4`}</li>
    </ul>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-14"
      }}>{`Equipment`}</h5>
      <p>{`H’aanit: Unequip all`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Sunshade`}</strong></p>
    <h4 {...{
      "id": "sunshade"
    }}>{`Sunshade`}</h4>
    <p>{`Talk to Ali in the marketplace`}</p>
    <h3 {...{
      "id": "primrose-ch1"
    }}>{`Primrose Ch.1`}</h3>
    <p>{`Replace H’aanit with Primrose`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-15"
      }}>{`Equipment`}</h5>
      <p>{`Primrose: Optimize, Empowering Bracelet, Empowering Necklace`}</p>
    </Menu>
    <h4 {...{
      "id": "helgenish-16-sp"
    }}>{`Helgenish (16 SP)`}</h4>
    <p>{`Cyrus use Icewind x3`}</p>
    <p>{`TP `}<strong parentName="p">{`Stillsnow`}</strong></p>
    <h3 {...{
      "id": "primrose-ch2"
    }}>{`Primrose Ch.2`}</h3>
    <h4 {...{
      "id": "rufus-the-left-hand-man-116-sp"
    }}>{`Rufus, The Left Hand Man (116 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`If you use Tonitrus here & Lightning Blast vs Albus 3 random battle you won't have enough SP for Albus.`}<br parentName="p"></br>{`
`}{`Lightning Blast instead of Tonitrus here almost kills, at normal levels ~800 short. Can make up damage with Therion Holy Light.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-26"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Lightning Blast x3`}</li>
      <li parentName="ul">{`Tressa: Donate BP x3 Cyrus`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-26"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Tonitrus Canere x4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`To skip Prim 3 Battle & get LVL45 Therion he needs to be > LVL42 223EXP after Rufus`}</p>
    </blockquote>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch3"
    }}>{`Primrose Ch.3`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-10"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Peacock Strut + Mole Dance, `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold Trap`}</li>
      </ul>
    </Menu>
    <p>{`Kill battle in here with Lightning Blast. Certain groups die to Fireball/Icewind.`}</p>
    <h4 {...{
      "id": "albus-the-right-hand-man-72-sp"
    }}>{`Albus, The Right Hand Man (72 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-27"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Primrose: Peacock Strut Cyrus`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-27"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephan’s Cyrus`}</li>
      <li parentName="ul">{`Cyrus: Lux Congerere x4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Everhold`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch4"
    }}>{`Primrose Ch.4`}</h3>
    <p>{`Can Steal L Stones and pick Pom L if needed.`}</p>
    <h4 {...{
      "id": "simeon-236-sp"
    }}>{`Simeon (236 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-28"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Tenebrae Operire`}</li>
      <li parentName="ul">{`Tressa/Therion: Defend`}</li>
      <li parentName="ul">{`Primrose: Peacock Cyrus`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-28"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephan’s Cyrus`}</li>
      <li parentName="ul">{`Therion: Steal x4 from Dancer Marionette (100%)`}</li>
      <li parentName="ul">{`Cyrus: Lightning Blast x4 Simeon`}</li>
    </ul>
    <h4 {...{
      "id": "simeon-the-puppet-master-72-sp"
    }}>{`Simeon, The Puppet Master (72 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`If Tressa & Cyrus before Simeon 2nd action, can Elemental Break x2 and Herb of Clamor with Silence T2.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-29"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus/Tressa: Herb of Clamor silenced character. If both are before Silence, Elemental Break x2.`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Primrose: Attack x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-29"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Attack x4`}</li>
      <li parentName="ul">{`Cyrus: Elemental Break / Heal Silence`}</li>
      <li parentName="ul">{`Tressa: Alephans Cyrus`}</li>
      <li parentName="ul">{`Primrose: Peacock Cyrus`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-17"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Lightning Blast x4 / Ignis Ardere x3`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Northreach`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`If short on cash, you want to do Victor's Hollow stuff before Northreach stuff so you can delay the Fortifying L purchase. You can also steal the Platinum Sword in the Tavern if you'd be short for Trinity Sword.`}</p>
    </blockquote>
    <h3 {...{
      "id": "therion-ch4-start"
    }}>{`Therion Ch.4 Start`}</h3>
    <p>{`Purchase/steal `}<strong parentName="p">{`Fortifying L`}</strong>{` and pick `}<strong parentName="p">{`Master’s Longbow`}</strong>{` in Tavern unless done earlier.`}</p>
    <blockquote>
      <p parentName="blockquote">{`This is the last Nut you get in the run. Use them anytime you go into the inventory to heal.`}</p>
    </blockquote>
    <p>{`Mandatory fight: Cyrus use Lightning Blast x3`}</p>
    <p>{`TP to `}<strong parentName="p">{`Victor’s Hollow`}</strong>{` after cutscene where Therion discovers the hideout`}</p>
    <h4 {...{
      "id": "victors-hollow"
    }}>{`Victor's Hollow`}</h4>
    <p>{`Talk to Alaic by the entrance and allure him (35%).`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`Battle-Tested Axe`}</strong>{` from Ned (down the stairs on the upper screen). Should have about $15000 after this to have enough for `}<strong parentName="p">{`Trinity Sword`}</strong>{`.`}</p>
    <p>{`Go into `}<strong parentName="p">{`Forest of No Return`}</strong>{`. Sidequest: Again with Alaic (talk to the bandit, Tonitrus Canere x3)`}</p>
    <p><strong parentName="p">{`HEAL AFTER THIS FIGHT`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-11"
      }}>{`Jobs`}</h5>
      <p>{`Cyrus: `}<strong parentName="p">{`Runelord`}</strong>{`, All skills besides Balogar's Blade, `}<strong parentName="p">{`Sorcerer`}</strong></p>
      <h5 {...{
        "id": "support-skills-8"
      }}>{`Support Skills`}</h5>
      <p>{`Cyrus: -Boost Start, +Elemental Edge`}</p>
      <h5 {...{
        "id": "equipment-16"
      }}>{`Equipment`}</h5>
      <p>{`Cyrus: Primeval Bow of Storms. `}<em parentName="p">{`Make sure you do this after Runelord menu`}</em>{`.`}</p>
      <h5 {...{
        "id": "inventory-2"
      }}>{`Inventory`}</h5>
      <ul>
        <li parentName="ul">{`Therion: All Nuts`}</li>
        <li parentName="ul">{`Plums on Cyrus if needed`}</li>
      </ul>
      <p><em parentName="p">{`Heal up`}</em>{`.`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Duskbarrow`}</strong></p>
    <h3 {...{
      "id": "cyrus-ch4"
    }}>{`Cyrus Ch.4`}</h3>
    <p><em parentName="p">{`Quiz: Option 2, Option 2, Option 2`}</em></p>
    <h4 {...{
      "id": "lucia-92-sp"
    }}>{`Lucia (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-30"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Elemental Break`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Primrose: Leghold Trap / Nothing if Cyrus before Lucia T2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-30"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephans Cyrus`}</li>
      <li parentName="ul">{`Therion: Aelfrics Cyrus`}</li>
      <li parentName="ul">{`Cyrus: Ventus Saltare x3`}</li>
    </ul>
    <p><em parentName="p">{`Quiz: Option 2, Option 3, Option 2.`}</em>{` Enjoy the credits`}</p>
    <h4 {...{
      "id": "atlasdam"
    }}>{`Atlasdam`}</h4>
    <p>{`Steal `}<strong parentName="p">{`Curious Bloom (100%)`}</strong>{` from man standing near the library to the south if you don't have one. Steal `}<strong parentName="p">{`Elemental Augementor (100%)`}</strong>{` from Therese inside the academy. TP `}<strong parentName="p">{`Northreach`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch4-continued"
    }}>{`Therion Ch.4 Continued`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Pom L`}</strong>{` from Seasoned Thief. If Therion is level 45 or higher, Brigand Leader’s Garb will be 55%, otherwise it’s 15%.`}</p>
    <p>{`Steal `}<strong parentName="p">{`Sprightly Necklace (80%)`}</strong>{` from man standing in the center of town.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Trinity Sword`}</strong>{` from weapons shop.`}</p>
    <h4 {...{
      "id": "darius-144-sp"
    }}>{`Darius (144 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Can go for T1 Break with any combo except Tressa + Therion.`}<br parentName="p"></br>{`
`}{`If Cyrus uses Ventus before another character attacks you'll need another M Stone`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-31"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Ventus / Elemental Break`}</li>
      <li parentName="ul">{`Tressa: Attack x2 / Defend / HHM`}</li>
      <li parentName="ul">{`Therion: Attack x2 / Defend /Shackle`}</li>
      <li parentName="ul">{`Primrose: Attack x2 / Nothing`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-31"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa OR Therion: Alephans/Aelfics Cyrus`}</li>
      <li parentName="ul">{`Cyrus: Ventus Saltare x3`}</li>
    </ul>
    <p><em parentName="p">{`If Darius gets 2 attacks off, probably someone will die. If you get Tressa or Therion before him, you can use Hired Help Mercenary or Shackle Foe to prevent this and delay the break until turn 2. Without Elemental Break, Ventus Saltare x4 with Alephan’s Enlightenment is a guaranteed finish as well.`}</em></p>
    <p>{`Go to `}<strong parentName="p">{`West S’warkii Trail`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Sidequest: Alphas and the Impresario (talk to Impresario)`}</p>
    <h4 {...{
      "id": "azure-eyed-tiger-33530hp"
    }}>{`Azure-eyed Tiger 33530HP`}</h4>
    <p>{`Ventus Saltare x4`}</p>
    <p>{`Talk to Impresario again to unlock `}<strong parentName="p">{`Ruins of Hornburg`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Marsalim`}</strong>{` to allure Maruf (man standing underneath the weapons shop, 32%), then TP `}<strong parentName="p">{`Sunshade`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Talk to Ali to complete sidequest: The Adventures of Ali.`}<br parentName="p"></br>{`
`}{`TP to `}<strong parentName="p">{`Ruins of Hornburg`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-12"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Runelord`}</strong>{`, Balogar’s Blade`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Warrior`}</strong>{`, all Warrior Skills, `}<strong parentName="li">{`Sorcerer`}</strong>{`, all Sorcerer Skills`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Merchant`}</strong></li>
      </ul>
      <p><em parentName="p">{`If not done already`}</em></p>
      <h5 {...{
        "id": "inventory-3"
      }}>{`Inventory`}</h5>
      <p>{`All nuts on Therion`}</p>
    </Menu>
    <p>{`Enter `}<strong parentName="p">{`Gate of Finis`}</strong></p>
    <h3 {...{
      "id": "gate-of-finis"
    }}>{`Gate of Finis`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-17"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Cyrus`}</strong>{`: Optimize, Empowering Bracelet, Mental Belt, REMOVE Werner's Sword`}</li>
        <li parentName="ul"><strong parentName="li">{`Tressa`}</strong>{`: Unequip All`}</li>
        <li parentName="ul"><strong parentName="li">{`Therion`}</strong>{`: -Elemental Shield +Enchanted Circlet -Empowering Necklace, +Unerring Bracelet`}</li>
        <li parentName="ul"><strong parentName="li">{`Tressa`}</strong>{`: Optimize, Elemental Shield, Adamantine Hat, Sorcerer’s Robe), Elemental Augmentor x2`}</li>
        <li parentName="ul"><strong parentName="li">{`Primrose`}</strong>{`: Gareth's Helm, Vendetta Coat, Empowering Necklace x2`}</li>
        <li parentName="ul"><strong parentName="li">{`Ophilia`}</strong>{`: Tempest Amulet, Unerring Bracelet if you have extra.`}</li>
        <li parentName="ul"><strong parentName="li">{`Alfyn`}</strong>{`: Optimize, Empowering Necklace, Empowering Bracelet, Double Tomahawk`}</li>
        <li parentName="ul"><strong parentName="li">{`Olberic`}</strong>{`: Trinity Sword, Hasty Helm, Sprightly Necklace x2`}</li>
        <li parentName="ul"><strong parentName="li">{`H’aanit`}</strong>{`: Tempest Amulet`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "miguel-bottom-row-second-from-the-left-170070hp"
    }}>{`Miguel? (Bottom row, second from the left) 170070HP`}</h4>
    <h5 {...{
      "id": "turn-1-32"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Pom S Self`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Primrose: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-32"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Bow`}</strong>{` x3`}</li>
      <li parentName="ul">{`Therion: `}<strong parentName="li">{`Bow`}</strong>{` x4`}</li>
      <li parentName="ul">{`Cyrus: Balogar’s Blade`}</li>
    </ul>
    <hr></hr>
    <h4 {...{
      "id": "no-balogars-backup"
    }}>{`No Balogars Backup`}</h4>
    <h5 {...{
      "id": "turn-1-33"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Ice Rune`}</li>
      <li parentName="ul">{`Tressa: Elemental Break x2`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Primrose: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-33"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Bow`}</strong>{` x3`}</li>
      <li parentName="ul">{`Therion: `}<strong parentName="li">{`Bow`}</strong>{` x4`}</li>
      <li parentName="ul">{`Cyrus: Attack`}</li>
      <li parentName="ul">{`Tressa: Pom M Self`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-18"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Lightning Blast x4`}</li>
      <li parentName="ul">{`Tressa: Ventus x4`}</li>
    </ul>
    <hr></hr>
    <h4 {...{
      "id": "simeon-bottom-row-far-left-176369hp"
    }}>{`Simeon? (Bottom row, far left) 176369HP`}</h4>
    <h5 {...{
      "id": "turn-1-34"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus/Primrose: Pom S Cyrus/Herb of Clamor on Cyrus or Tressa if silenced`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-34"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Attack x4`}</li>
      <li parentName="ul">{`Cyrus: Balogar’s Blade`}</li>
      <li parentName="ul">{`Tressa: Tradewinds x3`}</li>
    </ul>
    <Menu mdxType="Menu">
      <p>{`Replace `}<strong parentName="p">{`Primrose`}</strong>{` with `}<strong parentName="p">{`Alfyn`}</strong>{`.`}</p>
    </Menu>
    <h4 {...{
      "id": "dragon-bottom-row-far-right-174794hp"
    }}>{`Dragon? (Bottom row, far right) 174794HP`}</h4>
    <h5 {...{
      "id": "turn-1-35"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Defend / Balogar's if last`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
      <li parentName="ul">{`Therion: Donate BP x2 Cyrus`}</li>
      <li parentName="ul">{`Alfyn: Axe x2 (4 hits)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-35"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Balogar’s Blade`}</li>
      <li parentName="ul">{`Tressa: Tradewinds x3`}</li>
    </ul>
    <h4 {...{
      "id": "darius-bottom-row-second-from-the-right-188966hp"
    }}>{`Darius? (Bottom row, second from the right) 188966HP`}</h4>
    <h5 {...{
      "id": "turn-1-36"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`Can also break with Cyrus Axe + Therion Attack x3`}</em></li>
      <li parentName="ul">{`Cyrus: Pom S Self / Balogars`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
      <li parentName="ul">{`Therion: Shackle Foe / Donate BPx2 Cyrus`}</li>
      <li parentName="ul">{`Alfyn: Axe x2 (4 hits)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-36"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Balogar’s Blade`}</li>
    </ul>
    <h4 {...{
      "id": "mattias-top-row-far-left-149283hp"
    }}>{`Mattias? (Top row, far left) 149283HP`}</h4>
    <h5 {...{
      "id": "turn-1-37"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Defend / Balogar's if last`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
      <li parentName="ul">{`Therion: Donate BP x2 Cyrus`}</li>
      <li parentName="ul">{`Alfyn: Axe x2 (4 hits)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-37"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Balogar’s Blade`}</li>
    </ul>
    <h1 style={{
      color: 'red',
      fontSize: '72px'
    }}>DO THIS MENU BEFORE YVON</h1>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-13"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Dreisang’s Spell`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Warrior`}</strong>{`, All Skills`}</li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Starseer`}</strong></li>
      </ul>
      <h5 {...{
        "id": "skills-4"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: All Scholar Skills + Divine`}</li>
        <li parentName="ul">{`Alfyn: All Apothecary Skills + Divine`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills-9"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Augmented Elements, Elemental Aid, BP Eater, Surpassing Power`}</li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`-Cover`}</strong>{` +Boost-Start`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "yvon-top-row-second-from-the-left-163771hp"
    }}>{`Yvon? (Top row, second from the left) 163771HP`}</h4>
    <h5 {...{
      "id": "turn-1-38"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`Look for Alfyn or Therion before Cyrus T1. If so, Tressa Defend.`}</em></li>
      <li parentName="ul">{`Cyrus: Lightning Blast x2/x3`}</li>
      <li parentName="ul">{`Tressa: Tonitrus Canere x1 / Defend if Lightning Blast x3`}</li>
      <li parentName="ul">{`Therion: Attack x3 Yvon / Pom L Cyrus`}</li>
      <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Dagger`}</strong>{` x3 Yvon / Pom L Cyrus`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-38"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Balogar’s Blade Yvon`}</li>
      <li parentName="ul">{`Tressa: Ventus Saltare x3`}</li>
    </ul>
    <h4 {...{
      "id": "venomtooth-tiger-top-row-second-from-the-right-193691hp"
    }}>{`Venomtooth Tiger? (Top row, second from the right) 193691HP`}</h4>
    <h5 {...{
      "id": "turn-1-39"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Pom S Self`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
      <li parentName="ul">{`Therion: `}<strong parentName="li">{`Spear`}</strong>{` x3`}</li>
      <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Spear`}</strong>{` x3`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-39"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Balogar’s Blade`}</li>
    </ul>
    <h4 {...{
      "id": "werner-top-row-far-right-167865hp"
    }}>{`Werner? (Top row, far right) 167865HP`}</h4>
    <p><em parentName="p">{`Therion needs to be dead at the end of this fight`}</em></p>
    <h5 {...{
      "id": "turn-1-40"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Healing Grape M / Defend`}</li>
      <li parentName="ul">{`Tressa: Elemental Break x2`}</li>
      <li parentName="ul">{`Therion: Incite`}</li>
      <li parentName="ul">{`Alfyn: Soothing Dust + Curious Bloom`}</li>
    </ul>
    <p><em parentName="p">{`Werner will use Sweep and Double Strike on this turn. If he uses Sweep first and Therion dies, Double Strike will kill someone else. Be careful.`}</em></p>
    <h5 {...{
      "id": "turn-2-40"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Healing Grape M / Defend`}</li>
      <li parentName="ul">{`Alfyn: Defend / Axe x3 if Therion dead`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-19"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Axe x3 (6 hits)`}</li>
      <li parentName="ul">{`Cyrus: Balogar’s Blade`}</li>
    </ul>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia > Cyrus`}</li>
        <li parentName="ul">{`Tressa > Primrose`}</li>
        <li parentName="ul">{`H'aanit > Alfyn`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-14"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Merchant`}</strong>{`, 2 Skills, `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold Trap + Arrowstorm `}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Apothecary`}</strong>{`, 3 Skills, `}<strong parentName="li">{`Cleric`}</strong>{`, All Skills`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Warmaster`}</strong>{`, All Skills + Divine`}</li>
        <li parentName="ul">{`H’aanit: Leghold Trap + Arrowstorm, `}<strong parentName="li">{`Warrior`}</strong>{`, 2 Skills, `}<strong parentName="li">{`Merchant`}</strong>{`, 3 Skills, Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills-10"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Hang Tough, Cover `}</li>
        <li parentName="ul">{`Primrose: Persistence, Saving Grace, The Show Goes On, Hale & Hearty`}</li>
        <li parentName="ul">{`Therion: Fortitude, Physical Prowess, BP Eater, Surpassing Power`}</li>
        <li parentName="ul">{`H’aanit: Hang Tough, Cover`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-18"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Optimize, -Captain's Badge +Mighty Belt, `}<strong parentName="li">{`Swap Werner's Sword for Battle-Tested Blade`}</strong></li>
      </ul>
      <h5 {...{
        "id": "healing"
      }}>{`Healing`}</h5>
      <p><strong parentName="p">{`Primrose`}</strong>{`: Heal Wounds to full, `}<strong parentName="p">{`THEN`}</strong>{` Revive.`}</p>
      <hr></hr>
      <h5 {...{
        "id": "party-1"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus > Ophilia`}</li>
        <li parentName="ul">{`Therion > Tressa`}</li>
        <li parentName="ul">{`Alfyn > H'aanit`}</li>
      </ul>
    </Menu>
    <p>{`Party 1: Cyrus, Primrose, Tressa, Alfyn`}<br parentName="p"></br>{`
`}{`Party 2: Ophilia, Therion, Olberic, H'aanit`}</p>
    <h4 {...{
      "id": "omniscient-eye"
    }}>{`Omniscient Eye`}</h4>
    <p><em parentName="p">{`Assumes Cyrus goes after eye on turns 1 & 3 and Primrose after eye on turn 2.`}</em></p>
    <h5 {...{
      "id": "turn-1-41"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Heal / Defend if before Eye T1 & Prim is after Eye T2 / Attack`}</li>
      <li parentName="ul">{`Primrose: Peacock Strut x2 Tressa`}</li>
      <li parentName="ul">{`Tressa: Defend / Heal if before Add T2`}</li>
      <li parentName="ul">{`Alfyn: Defend / Heal if before Primrose T2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-41"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Dohter’s Charity Primrose `}</li>
      <li parentName="ul">{`Tressa: Lux Congerere x3 `}</li>
      <li parentName="ul">{`Cyrus: Heal / Attack`}</li>
      <li parentName="ul">{`Primrose: Revitalizing Jam on everybody`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-20"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`See below for backup if Cyrus is before eye`}</em>{` `}</li>
      <li parentName="ul">{`Cyrus: Lightning Blast x3`}</li>
      <li parentName="ul">{`Primrose: Aelfrics Tressa`}</li>
      <li parentName="ul">{`Alfyn: Defend `}</li>
      <li parentName="ul">{`Tressa: Dreisang’s Spell Self `}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-3"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Attack x4 (8 hits) `}</li>
      <li parentName="ul">{`Cyrus: Alephans Tressa `}</li>
      <li parentName="ul">{`Tressa: Elemental Break `}</li>
      <li parentName="ul">{`Primrose: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-2"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: Revitalizing Jam on everybody `}</li>
      <li parentName="ul">{`Cyrus: Balogar’s Blade `}</li>
      <li parentName="ul">{`Tressa: Ventus Saltare x4 `}</li>
      <li parentName="ul">{`Alfyn: Nothing / L Stone if missing equipment`}</li>
    </ul>
    <hr></hr>
    <h4 {...{
      "id": "if-turn-3-cyrus-before-eye-tressa-after-eye-tressa-full-sp"
    }}>{`If Turn 3 Cyrus before Eye, Tressa after Eye, Tressa full SP`}</h4>
    <h5 {...{
      "id": "turn-3-21"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Alephan's Tressa`}</li>
      <li parentName="ul">{`Tressa: Tradewinds x3`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
      <li parentName="ul">{`Primrose: Aelfrics Tressa`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: 4x Attack (break)`}</li>
      <li parentName="ul">{`Cyrus: 3x Lightning Blast`}</li>
      <li parentName="ul">{`Tressa: 4x Ventus`}</li>
      <li parentName="ul">{`Primrose: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-3"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: Revitalizing Jam`}</li>
      <li parentName="ul">{`Cyrus: Balogar’s Blade `}</li>
      <li parentName="ul">{`Tressa: Ventus Saltare x4 `}</li>
    </ul>
    <h4 {...{
      "id": "galdera-the-fallen"
    }}>{`Galdera, The Fallen`}</h4>
    <p><em parentName="p">{`Assumes Olberic goes before Therion always & Ophilia or H’aanit after Galdera turn 2`}</em></p>
    <h5 {...{
      "id": "turn-1-42"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Pom L Therion`}</li>
      <li parentName="ul">{`Ophilia/H’aanit: Leghold Trap Abyssal Maw `}</li>
      <li parentName="ul">{`Therion: Winnehild’s Battle Cry / Nightmare Chimera Werner's Sword Abyssal Maw if first.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-42"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Pom L Therion`}</li>
      <li parentName="ul">{`Therion: Winnehild’s Battle Cry (if Ophilia & H’aanit are both before Galdera, which is unlikely, defend and use Battle Cry next turn) `}</li>
      <li parentName="ul">{`Ophilia/H’aanit: Leghold Trap as soon as Galdera unprotects himself. (If both before Galdera, use Arrowstorm to break Abyssal Maw)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-22"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Olberic: Thousand Spears / Spear x4 / Armor Corrosive`}</li>
      <li parentName="ul">{`Ophilia: Rain of Arrows / Bow x4`}</li>
      <li parentName="ul">{`H’aanit: Bow x4`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive / Spear x4 / Winnehild`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-5"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Winnehild’s Battle Cry`}</li>
    </ul>
    <p>{`Stop time at Spurning Ribbon pop-up`}</p>
    <h2 {...{
      "id": "fin"
    }}>{`FIN`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      